export default __webpack_public_path__ + "static/media/bedroom-5.4cd222ff.png";